export const USER_AUTHENTICATED = "userAuthenticated";
export const USER_UNAUTHENTICATED = "userUnauthenticated";
export const USER_TOKEN_REFRESHED = "userTokenRefreshed";
export const USER_UPDATED = "userUpdated";
export const COMPANY_UPDATED = "companyUpdated";
export const COMPANY_LOGO_UPDATED = "companyLogoUpdated";
export const IS_ERROR = "isError";
export const IS_REDIRECT = "isRedirect";